import { render, staticRenderFns } from "./LoanDetail.vue?vue&type=template&id=cb85e98e&"
import script from "./LoanDetail.vue?vue&type=script&lang=js&"
export * from "./LoanDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetail.vue?vue&type=style&index=0&id=cb85e98e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports